<template>
  <div class="privacy-policy">
    <h2 class="privacy-policy__title text-title">Privacy Policy</h2>

    <p class="privacy-policy__section-title">How We Collect and Use Information</p>
    <p class="privacy-policy__sub-title">
      We collect the following types of information about you:
    </p>

    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">
      Information you provide us directly:
    </p>
    <p class="privacy-policy__text text-base">
      We ask for certain information such as your username, real name, birthdate, address, phone
      number and e-mail address when you register for a The Grotta House account, or if you
      correspond with us. We may also retain any messages you send through the Service and may
      collect information you provide in User Content you post to the Service. We use this
      information to operate, maintain, and provide to you the features and functionality of the
      Service. Your username and if you choose to disclose it, your real name, will be published
      publicly. Once published your username and / or real name may not be able to be removed.
    </p>

    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">Analytics information:</p>
    <p class="privacy-policy__text text-base">
      We may directly collect analytics data, or use third-party analytics tools and services, to
      help us measure traffic and usage trends for the Service. These tools collect information sent
      by your browser or mobile device, including the pages you visit and other information that
      assists us in improving the Service. We collect and use this analytics information in
      aggregate form such that it cannot reasonably be manipulated to identify any particular
      individual user.
    </p>

    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">Cookies information:</p>
    <p class="privacy-policy__text text-base">
      When you visit the Service, we may send one or more cookies — a small text file containing a
      string of alphanumeric characters — to your computer that uniquely identifies your browser and
      lets The Grotta House help you log in faster and enhance your navigation through the site. A
      cookie may also convey information to us about how you use the Service (e.g., the pages you
      view, the links you click and other actions you take on the Service) and allow us or our
      business partners to track your usage of the Service over time. A persistent cookie remains on
      your hard drive after you close your browser. Persistent cookies may be used by your browser
      on subsequent visits to the site. Persistent cookies can be removed by following your web
      browser’s directions. A session cookie is temporary and disappears after you close your
      browser. You can reset your web browser to refuse all cookies or to indicate when a cookie is
      being sent. However, some features of the Service may not function properly if the ability to
      accept cookies is disabled.
    </p>

    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">Log file information:</p>
    <p class="privacy-policy__text text-base">
      Log file information is automatically reported by your browser or mobile device each time you
      access the Service. When you use our Service, our servers automatically record certain log
      file information. These server logs may include anonymous information such as your web
      request, Internet Protocol (“IP”) address, browser type, referring / exit pages and URLs,
      number of clicks and how you interact with links on the Service, domain names, landing pages,
      pages viewed, and other such information.
    </p>

    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">
      Clear gifs/web beacons information:
    </p>
    <p class="privacy-policy__text text-base">
      When you use the Service, we may employ clear gifs (also known as web beacons) which are used
      to anonymously track the online usage patterns of our Users. In addition, we may also use
      clear gifs in HTML-based emails sent to our users to track which emails are opened and which
      links are clicked by recipients. The information is allowed for more accurate reporting and
      improvement of the Service.
    </p>

    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">Device identifiers:</p>
    <p class="privacy-policy__text text-base">
      When you access the Service by or through a mobile device (including but not limited to
      smart-phones or tablets), we may access, collect, monitor and/or remotely store one or more
      “device identifiers,” such as a universally unique identifier (“UUID”). Device identifiers are
      small data files or similar data structures stored on or associated with your mobile device,
      which uniquely identify your mobile device. A device identifier may be data stored in
      connection with the device hardware, data stored in connection with the device’s operating
      system or other software, or data sent to the device by The Grotta House. A device identifier
      may convey information to us about how you browse and use the Service. A device identifier may
      remain persistently on your device, to help you log in faster and enhance your navigation
      through the Service. You may be able to set your device to remove device identifiers. However,
      some features of the Service may not function properly if use or availability of device
      identifiers is impaired or disabled.
    </p>
    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">Location data:</p>
    <p class="privacy-policy__text text-base">
      When you access the Service by or through a mobile device, we may access, collect, monitor
      and/or remotely store “location data,” which may include GPS coordinates (e.g. latitude and/or
      longitude) or similar information regarding the location of your mobile device. Location data
      may convey to us information about how you browse and use the Service. You may be able to set
      your device to prevent collection of location data. However, some features of the Service,
      particularly location-based services, may not function properly if use or availability of
      location data is impaired or disabled.
    </p>
    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">
      Commercial and marketing communications:
    </p>
    <p class="privacy-policy__text text-base">
      We use the information we collect or receive, such as your email address, to communicate
      directly with you. We may send you emails containing newsletters, promotions, and special
      events. If you do not want to receive such email messages, you will be given the option to opt
      out or change your preferences. We also use your information to send you Service-related
      emails (e.g., account verification, purchase and billing confirmations and reminders,
      changes/updates to features of the Service, technical and security notices). You may not opt
      out of Service-related emails.
    </p>
    <p class="privacy-policy__sub-title privacy-policy__new-paragraph">
      Use of certain service type information we collect about you:
    </p>
    <p class="privacy-policy__text text-base">
      We use or may use cookies, log file, device identifiers, location data and clear gifs
      information to: (a) remember information so that you will not have to re-enter it during your
      visit or the next time you visit the site; (b) provide custom, personalized content and
      information; (c) to provide and monitor the effectiveness of our Service; (d) monitor
      aggregate metrics such as total number of visitors, traffic, and demographic patterns; (e)
      diagnose or fix technology problems; (f) help you efficiently access your information after
      you sign in, and (g) automatically update the The Grotta House application on your mobile
      devices.
    </p>

    <p class="privacy-policy__section-title privacy-policy__new-paragraph">
      Sharing of Your Information
    </p>
    <p class="privacy-policy__text text-base">
      We will not rent or sell your information to third parties outside The Grotta House and its
      group companies (including any parent, subsidiaries and affiliates) without your consent,
      except we may share your information with third-party business partners and Trusted Users for
      the purpose of providing the Service to you. Third-party business partners will be given
      limited access to your information as is reasonably necessary to deliver the Service, and we
      will require that such third parties comply with this Privacy Policy, or operate under a
      similar privacy policy.
    </p>

    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      <span class="privacy-policy__question">
        What happens in the event of a change of control:
      </span>
      We may sell/divest/transfer The Grotta House or a portion of its products, services, assets
      and/or businesses. If this occurs, your information such as customer names and email
      addresses, User Content and other user information related to the Service may be among the
      items sold or otherwise transferred in such a transaction. In the event of a change of
      control, we will ask the recipient of your personal information to notify you so that you may
      change your preferences at that time.
    </p>
    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      <span class="privacy-policy__question">
        Instances where we are required to share your information:
      </span>
      The Grotta House cooperates with government and law enforcement officials to enforce and
      comply with the law. We may therefore disclose personal information, usage data, message data,
      and any other information about you, if we deem that it is reasonably necessary to: (a)
      satisfy any applicable law, regulation, legal process (such as a subpoena or court order), or
      enforceable governmental request; (b) enforce the Terms of Use, including investigation of
      potential violations thereof; (c) detect, prevent, or otherwise address fraud, security or
      technical issues; or (d) protect against harm to the rights, property or safety of The Grotta
      House, its users or the public, as required or permitted by law.
    </p>
    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      <span class="privacy-policy__question">
        Sharing certain service type information we collect about you:
      </span>
      We may share certain service type information, including information obtained through tools
      such as cookies, log files, device identifiers, location data and clear gifs (such as
      anonymous usage data, referring/exit pages and URLs, platform types, number of clicks, etc.):
      (i) with our third-party business partners for the purposes described in the section above on
      “How We Collect and Use Information.” We may also aggregate or otherwise strip data of all
      personally identifying characteristics and may share that aggregated, anonymized data with
      third parties.
    </p>

    <p class="privacy-policy__section-title privacy-policy__new-paragraph">
      How We Store and Protect Your Information
    </p>
    <p class="privacy-policy__text text-base">
      <span class="privacy-policy__question">Storage and Processing:</span>
      Your information collected through the Service will be stored and processed in the United
      States. Therefore, the information that The Grotta House collects will be subject to the laws
      of the United States of America, regardless of the country from which your information
      originates.
    </p>
    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      <span class="privacy-policy__question">Keeping your information safe:</span>
      The Grotta House cares about the security of your information and uses commercially reasonable
      safeguards to preserve the integrity and security of all information collected through the
      Service. To protect your privacy and security, we take reasonable steps (such as requesting a
      unique password) to verify your identity before granting you access to your account. You are
      responsible for maintaining the secrecy of your unique password and account information, and
      for controlling access to your email communications from The Grotta House at all times. The
      Grotta House cannot ensure or warrant the security of any information you transmit to The
      Grotta House or guarantee that information on the Service may not be accessed, disclosed,
      altered, or destroyed so you do so at your own risk. Your privacy settings may also be
      affected by changes to the functionality of third-party sites and services that you add to The
      Grotta House Service, such as social networks. The Grotta House is not responsible for the
      functionality or security measures of any third party.
    </p>
    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      <span class="privacy-policy__question">Compromise of information:</span>
      In the event that any information under our control is compromised as a result of a breach of
      security, The Grotta House will take reasonable steps to investigate the situation and where
      appropriate, notify those individuals whose information may have been compromised and take
      other steps, in accordance with any applicable laws and regulations.
    </p>

    <p class="privacy-policy__section-title privacy-policy__new-paragraph">
      Your Choices about Your Information
    </p>
    <p class="privacy-policy__text text-base">
      <span class="privacy-policy__question"
        >You control your account information and settings:</span
      >
      You may update your account information and email-communication preferences at any time by
      logging in to your account and changing your profile settings. originates.
    </p>
    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      We make every effort to promptly process all unsubscribe requests. As noted above, you may not
      opt out of Service-related communications (e.g., account verification, purchase and billing
      confirmations and reminders, changes/updates to features of the Service, technical and
      security notices).
    </p>
    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      <span class="privacy-policy__question"
        >Opting out of collection of your information for Tracking / Advertising:</span
      >
      Please refer to your mobile device or browser’s technical information for instructions on how
      to delete and disable cookies, and other tracking/recording tools. Depending on your type of
      device, it may not be possible to delete or disable tracking mechanisms on your mobile device.
      Note that disabling cookies and/or other tracking tools prevents The Grotta House or its
      business partners from tracking your browser’s activities in relation to the Service. However,
      doing so may disable many of the features available through the Service.
    </p>
    <p class="privacy-policy__text text-base privacy-policy__new-paragraph">
      <span class="privacy-policy__question"
        >How long we keep your private profile information:</span
      >
      Following termination of your User account, The Grotta House may retain your private profile
      information for a commercially reasonable time for backup, archival, or audit purposes. To be
      clear, any information that you choose to make public on the service may not be removable.
    </p>

    <p class="privacy-policy__section-title privacy-policy__new-paragraph">Children’s Privacy</p>
    <p class="privacy-policy__text text-base">
      The Grotta House will not knowingly collect personally identifiable information from any
      person that is actually known to us to be a child under the age of 13 years old. If you are
      under 13 years of age, please do not use or access our website or services.
    </p>
    <p class="privacy-policy__section-title privacy-policy__new-paragraph">
      Links to Other Websites and Services
    </p>
    <p class="privacy-policy__text text-base">
      We are not responsible for the practices employed by websites or services linked to or from
      the Service, including the information or content contained therein. Please remember that when
      you use a link to go from the Service to another website, our Privacy Policy does not apply to
      third-party websites or services. Your browsing and interaction on any third-party website or
      service, including those that have a link on our website, are subject to that third party’s
      own rules and policies. In addition, you agree that we are not responsible and we do not have
      control over any third parties that you authorize to access your User Content. You will
      receive a notice when you leave our website and go to a third-party site. If you are using a
      third-party website or service (like Facebook, Google groups, or an IRC chatroom) and you
      allow such a third-party access to your User Content you do so at your own risk.
    </p>
    <p class="privacy-policy__section-title privacy-policy__new-paragraph">
      Changes to this Privacy Policy
    </p>
    <p class="privacy-policy__text text-base">
      We may modify this Privacy Policy from time to time and with no notice to Users. It is your
      responsibility to check this Privacy Policy for any changes. Changes will be effective
      immediately upon their posting to this site.
    </p>

    <p class="privacy-policy__section-title privacy-policy__new-paragraph">For EU Residents:</p>
    <p class="privacy-policy__text text-base">
      In an effort to give you more control over how your data is used, we would like to make sure
      you are fully aware of all of your data protection rights. Every user is entitled to the
      following:
    </p>

    <ul class="privacy-policy__list">
      <li class="privacy-policy__list_item">
        <span class="privacy-policy__underline">The right to access</span> – You have the right to
        request copies of your personal data from us.
      </li>
      <li class="privacy-policy__list_item">
        <span class="privacy-policy__underline">The right to correction</span>
        – You have the right to request that we correct any information you believe is inaccurate.
      </li>
      <li class="privacy-policy__list_item">
        <span class="privacy-policy__underline">The right to erasure</span>
        – You have the right to request we erase your personal information under certain conditions.
      </li>
      <li class="privacy-policy__list_item">
        <span class="privacy-policy__underline">The right to restrict processing</span>
        – You have the right to request that we restrict the processing of your personal information
        under certain conditions.
      </li>
      <li class="privacy-policy__list_item">
        <span class="privacy-policy__underline">The right to object to processing</span>
        – You have the right to object to our processing of your personal data under certain
        conditions.
      </li>
      <li class="privacy-policy__list_item">
        <span class="privacy-policy__underline">The right to data portability</span>
        – You have the right to request that we transfer the data that we have collected to another
        organization or directly to you under certain conditions.
      </li>
    </ul>

    <p class="privacy-policy__text text-base">
      If you make a request, we have one month from our receipt of your notice to respond to you. If
      you would like to exercise any of these rights,
    </p>
    <p class="privacy-policy__text text-base">Email us at: info@grottahouse.com</p>
    <p class="privacy-policy__text text-base">Call us at: 203.834.0623</p>
    <p class="privacy-policy__text text-base">
      Or write to us: 276 Ridgefield Road • Wilton, CT • 06897
    </p>

    <p class="privacy-policy__section-title privacy-policy__new-paragraph">
      For California Residents:
    </p>
    <p class="privacy-policy__text text-base">
      In an effort to give you more control over how your data is used, we would like to make sure
      you are fully aware of all of your data protection rights. Every user is entitled to the
      following:
    </p>

    <ul class="privacy-policy__list">
      <li class="privacy-policy__list_item privacy-policy__underline">The right to know</li>
      <li class="privacy-policy__list_item privacy-policy__underline">The right to deletion</li>
      <li class="privacy-policy__list_item privacy-policy__underline">
        The right to Non-discrimination
      </li>
      <li class="privacy-policy__list_item privacy-policy__underline">
        The right to opt out of sales
      </li>
    </ul>

    <p class="privacy-policy__text text-base">
      If you make a request, we have 45 days from our receipt of your request to respond to you. If
      you would like to exercise any of these rights,
    </p>
    <p class="privacy-policy__text text-base">Email us at: info@grottahouse.com</p>
    <p class="privacy-policy__text text-base">Call us at: 203.834.0623</p>
    <p class="privacy-policy__text text-base">
      Or write to us: 276 Ridgefield Road • Wilton, CT • 06897
    </p>

    <p class="privacy-policy__section-title privacy-policy__new-paragraph">
      Last Posted: <span class="privacy-policy__text text-base">May 2022</span>
    </p>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  components: {},

  data() {
    return {};
  },
  head: {
    title: function () {
      return {
        inner: "GH - Privacy Policy",
        separator: " ",
        complement: " ",
      };
    },
    meta: function () {
      return [];
    }
  },
  computed: {},

  created() {
    const breadcrumbs = [
      {
        title: "Home",
        to: "/",
      },
      {
        title: "Privacy Policy",
        to: "/privacy-policy",
      },
    ];
    this.setBreadcrumbs(breadcrumbs);
  },

  methods: {
    ...mapMutations(["setBreadcrumbs"]),
  },
};
</script>

<style lang="scss" scoped>
.privacy-policy {
  min-height: 100vh;
  min-width: 100vw;
  padding: 17rem 31.5rem 18rem;
  @media screen and (max-width: $md) {
    padding: 17rem 10.5rem 18rem;
  }
  @media screen and (max-width: $xs) {
    padding: 28rem 25px 18rem;
  }
  &__title {
    font-size: 62px;
    line-height: 1.1;
    letter-spacing: -1.03px;
    font-family: $fontBodoni;
    font-weight: 500;
    margin-bottom: 95px;
    text-align: center;
    @media (max-width: $xs) {
      font-size: 4rem;
      line-height: 6rem;
    }
  }
  &__section-title {
    font-size: 27px;
    line-height: 1.3;
    letter-spacing: -0.45px;
    font-family: $fontBodoni;
    margin-bottom: 10px;
    font-weight: 500;
    color: $white;
  }
  &__sub-title {
    font-size: 21px;
    line-height: 1.66;
    font-weight: 500;
    color: $white;
  }
  &__text {
    font-size: 21px;
    line-height: 1.66;
    font-weight: 100;
    text-align: justify;
    font-family: $fontOpenSans;
  }
  &__new-paragraph {
    margin-top: 40px;
  }
  &__question {
    font-size: 21px;
    line-height: 1.66;
    font-weight: 100;
    font-family: $fontOpenSans;
    color: $white;
    font-style: italic;
    margin-right: 10px;
  }
  &__underline {
    font-size: 21px;
    line-height: 1.66;
    font-weight: 100;
    font-family: $fontOpenSans;
    color: $white;
    text-decoration: underline;
  }

  &__list {
    list-style-type: disc;
    list-style-position: inside;
    margin-block-start: 20px;
    margin-block-end: 20px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 100px;
    @media screen and (max-width: $md) {
      padding-inline-start: 80px;
    }
    @media screen and (max-width: $xs) {
      padding-inline-start: 40px;
    }
    &_item {
      font-size: 21px;
      line-height: 1.66;
      font-weight: 100;
      text-align: justify;
      font-family: $fontOpenSans;
      color: $white;
      &::marker {
        font-size: 13px;
      }
    }
  }
}
</style>
